import { object, string } from 'yup';
import { TFunction } from 'i18next';

export function makePasswordResetSchema(t: TFunction) {
  return object().shape({
    email: string().email(t('form.emailInvalid')).required(t('form.required')),
  });
}
